import SelectComponent from "../../ui/select/SelectComponent";
import * as React from "react";
import {Place} from "../ScheduleMap";
import DateUtils from "../../../utils/DateUtils";
import AppointmentDetails from "../../../model/appointment/AppointmentDetails";
import classNames = require("classnames");

export default class SelectPlace extends SelectComponent<Place> {
	matchFilter(element: Place, filter: string): boolean {
		return element.text.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: Place): string {
		return element.id;
	}

	elementToString(element: Place) {
		return element.text;
	}

	renderOption(props: any) {
		const classFromProps = classNames({
			"c-select-component__option": true,
			"c-select-component__option--is-selected": props.isSelected,
			"c-select-component__option--is-focused": props.isFocused,
		});

		return (<div ref={props.innerRef} {...props.innerProps} className={classFromProps}>
				{props.data.appointmentDetail.map((ad: AppointmentDetails) =>
						<span>
				<strong>{ad.getReferenceNumber()}</strong><br/>
							{ad.appointment.dateTime.format(DateUtils.DATE_TIME_FORMAT)}<br/>
							{ad.individualContact.data.displayName()}<br/>
							{ad.site.map(s => <>{s.data.address.postcode}<br/></>).orNull}
							{ad.getSalesEngineers().getOrElse([]).map(se => se.getDisplayName()).join(", ")}
			</span>
				).getOrElse(
					<span>{props.data.text}</span>
				)}
			</div>
		)
	}

	renderValue(props: any) {
		const classFromProps = classNames({
			"c-select-component__control": true,
			"c-select-component__control--is-focused": props.isFocused,
		});
		return (
			<div ref={props.innerRef} {...props.innerProps} className={classFromProps}>
				<span>{this.getText(props.data)}</span>
			</div>
		);
	}

	getText(data: any) {
		if (data.appointmentDetail) {
			return data.appointmentDetail.map(
				(ad: AppointmentDetails) => `${ad.appointment.referenceNumber.get} ${ad.appointment.dateTime.format(
					DateUtils.DATE_TIME_FORMAT)}`).getOrElse(data.text)
		}
		return data.text;
	}
}
